import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold font-heading">快猫短视频</span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              快猫短视频 —— 海量优质短视频内容平台。
              <br />
              记录美好，分享快乐。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">产品</h4>
            <div className="flex flex-col gap-2">
              <Link to="/category/funny" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">浏览分类</Link>
              <a href="#download" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">下载 App</a>
              <a href="#creator" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">创作者入驻</a>
              <Link to="/article/2" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">会员服务</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">关于</h4>
            <div className="flex flex-col gap-2">
              <Link to="/about" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">关于我们</Link>
              <Link to="/article/3" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">安全审核</Link>
              <Link to="/article/4" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">创作指南</Link>
              <a href="#" className="text-sm text-foreground-300 hover:text-background-50 transition-colors">隐私政策</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-4">联系方式</h4>
            <div className="flex flex-col gap-2">
              <span className="text-sm text-foreground-300">contact@kuaimao.com</span>
              <span className="text-sm text-foreground-300">0571-8888-6666</span>
              <span className="text-sm text-foreground-300">杭州市余杭区未来科技城</span>
            </div>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="微信公众号">
                <i className="ri-wechat-2-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="新浪微博">
                <i className="ri-weibo-line text-background-50"></i>
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-foreground-800 flex items-center justify-center hover:bg-primary-500 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-background-50"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 快猫短视频 版权所有 | 浙ICP备XXXXXXXX号-1
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-background-50 transition-colors">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}